export function GetProductSettingsHandler(userProducts) {

    const product =  {
        "plan": true,
        "planMax": 2,
        "planCreation": true,
        "planDelete": true,
        "planSearch": true,
        "planCertificate": true,
        "planOrderChange": true,
        "planSearchTags": true,
        "orders": true,
        "ordersCreation": true,
        "ordersDelete": true,
        "ordersSearch": true,
        "ordersSearchTags": true,
        "ordersTenderOption": ["direct"],
        "users": true,
    };


    const products = {
        "xs": {
            "usersMax": 1,
        },
        "s": {
            "maps": true,
            "mapsCreation": true,
            "mapsSearch": true,
            "mapsDelete": true,
            "mapsShareLink": true,
            "mapsMax": 20,
            "planMax": 20,
            "usersMax": 3,
            "ordersTenderOption": ["direct"],
        },
        "m": {
            "maps": true,
            "mapsCreation": true,
            "mapsSearch": true,
            "mapsDelete": true,
            "mapsShareLink": true,
            "mapsMax": 50,
            "planMax": 50,
            "usersMax": 10,
            "ordersTenderOption": ["direct"],
        },
        "l": {
            "maps": true,
            "mapsCreation": true,
            "mapsSearch": true,
            "mapsDelete": true,
            "mapsShareLink": true,
            "mapsMax": 100,
            "planMax": 100,
            "usersMax": 20,
            "ordersTenderOption": ["direct"],
        },
        "xl": {
            "maps": true,
            "mapsCreation": true,
            "mapsSearch": true,
            "mapsDelete": true,
            "mapsShareLink": true,
            "mapsMax": 500,
            "planMax": 9999,
            "usersMax": 999,
            "ordersTenderOption": ["direct"],
        },
        "creator": {
            "ordersTender": true,
            "ordersManagement": true,
        },
        "wfs": {
            "mapsWFS": true,
        },
        "communitiesAdministator": {
            "communityFilter": true,
            "additionalFilter": true,
            "ordersCounter": true,
            "cardGridShowOwner": true,
        },
        "hf": {
            "projects": true,
            "projectsMax": 999,
            "projectsCreation": true,
            "projectsDrafts": true,
            "documents": true,
            "documentsGeno": true,
            "openData": true,
        },
    }

    if(typeof userProducts !== "undefined" && userProducts !== null && userProducts.length > 0) {
        for (let a of userProducts) {
            if(typeof products[a] !== "undefined") {
                Object.assign(product, products[a]);
            }
        }
    }

    return product;
}


export function verifyPermissions(company, permission) {
    if(typeof company?.["permissions"]?.[permission] !== "undefined") {
        return company?.["permissions"]?.[permission];
    } else {
        return false;
    }
}